import React, { createContext, useContext, useState, useEffect } from "react";
import de from "./de";
import en from "./en";
import fr from "./fr";

const map = { de, en, fr };
const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("barlow_lang") || "de");

  useEffect(() => {
    localStorage.setItem("barlow_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "de" ? "en" : "de"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, c: map[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
export const useContent = () => useContext(LanguageContext).c;
